import BasicInformationPage from './BasicInformationPage';

export default BasicInformationPage;
